import React, { useState, useEffect } from 'react';
import { useFetch } from '../../../../helpers/hooks/fetchData';
import styled from 'styled-components';
import { Modal } from '../../../shared/modal/Modal';
import { Button } from '../../../shared/button/Button';

export const DeleteQuestion = ({ question, showModal, setShowModal }) => {
  const [payload, setPayload] = useState({
    title: '',
  });
  const { data, hasError } = useFetch(payload);
  const errorText = 'Error deleting question';

  useEffect(() => {
    if (data) {
      setShowModal(false);
      return window.location.reload();
    }
  }, [data, setShowModal]);

  const deleteQuestion = () => {
    if (!question || !question._id) {
      return false;
    }
    setPayload({
      endpoint: '/api/omega/questions/archive/' + question._id,
      method: 'patch',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
  };

  return (
    <>
      {showModal && (
        <Modal
          show={showModal}
          handleExit={setShowModal}
          title='Delete question'
          width={'40rem'}
        >
          {!hasError && (
            <>
              <Label>Are you sure you want to delete this question?</Label>
              <Margin />
              <Button
                type='submit'
                onClick={deleteQuestion}
                primary
                text='Delete'
              />

              <PaddingBetweenButton />
              <Button
                onClick={() => setShowModal(false)}
                secondary
                text='Cancel'
                type='reset'
              />
            </>
          )}
          {hasError && (
            <>
              <ErrorMessage>{errorText}</ErrorMessage>
              <Button secondary onClick={() => setShowModal(false)} text='OK' />
            </>
          )}
        </Modal>
      )}
    </>
  );
};

const Label = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
`;
const ErrorMessage = styled.div`
  color: red;
  font-size: 2rem;
  text-align: center;
  margin-bottom: 30px;
`;

const Margin = styled.div`
  height: ${(props) => props.theme.spacing.small};
`;
const PaddingBetweenButton = styled.div`
  height: ${(props) => props.theme.spacing.standard};
`;
